@if(((eventService.nextEvents$ | async) ?? []).length > 0 || ((newsResource.value()?.newsArticles) ?? []).length > 0) {
    <button mat-icon-button
    routerLink="/aktuell"  aria-label="Aktuelle Nachrichten und nächste Termine">
    <mat-icon color="primary" class="material-icons-outlined" aria-hidden="false"
        [matBadge]="((newsResource.value()?.newsArticles) ?? []).length + ((eventService.nextEvents$ | async) ?? []).length"
        matBadgeColor="primary" matBadgeSize="small">message</mat-icon>
    </button>
}

